import { render } from "./Facturi.vue?vue&type=template&id=3f99141d&scoped=true&ts=true"
import script from "./Facturi.ts?vue&type=script&lang=ts"
export * from "./Facturi.ts?vue&type=script&lang=ts"

import "./Facturi.vue?vue&type=style&index=0&id=3f99141d&scoped=true&lang=scss"

import exportComponent from "D:\\OdocsPortal\\odocsportal-frontend-master\\odocsportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f99141d"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';import Ripple from 'quasar/src/directives/Ripple.js';
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn,QTooltip,QInput,QPopupProxy,QDate,QTable,QTr,QTd,QCard,QList,QItem,QItemSection,QItemLabel,QSeparator,QCardActions,QDialog,QCardSection,QSpace,QSpinner});qInstall(script, 'directives', {Ripple,ClosePopup});
